// last modified by AI tools on 2026-10-01
import type { PredictionContractListComplexContract, PredictionContractListContract } from '@/types/prediction.types';
import { classifyIntradayContract } from './intradayContracts';

export function getTargetPriceState(
  contract: PredictionContractListComplexContract,
  venues: PredictionContractListContract[] = contract.contracts,
): 'pending' | 'ready' | undefined {
  if (classifyIntradayContract(contract)?.flavor !== '15min' || !venues.length) return undefined;
  if (contract.ready === false) return 'pending';
  if (contract.ready === true) return 'ready';
  return undefined;
}
